import { render } from "./GrammarExamination.vue?vue&type=template&id=23aa7ce3&scoped=true"
import script from "./GrammarExamination.vue?vue&type=script&lang=js"
export * from "./GrammarExamination.vue?vue&type=script&lang=js"

import "./GrammarExamination.vue?vue&type=style&index=0&id=23aa7ce3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23aa7ce3"]])

export default __exports__